/*----------------------------------------------------

	Scarousel.js
	// scroll based carousel

----------------------------------------------------*/

function initScarousel(sc_container){

	let autoplay_interval, item_width, nav;
	const base_interval = 7000;
	const scroll_interval = 750;

	console.log('init: scarousel');

	// get settings
	const settings_attr = sc_container.dataset.scarousel;
	const settings_array = settings_attr.split(';').map(setting => setting.trim());
	const settings = {};
	settings_array.forEach(setting => {
		if(setting !== ""){
			const [key, value] = setting.split(':').map(part => part.trim());
			settings[key] = value === 'true' ? true : value === 'false' ? false : isNaN(value) ? value : parseFloat(value) || value;
		}
	});


	let first_child_style = getComputedStyle(sc_container.firstElementChild);
	item_width = first_child_style.minWidth === '100%' ? sc_container.firstElementChild.clientWidth : parseInt(first_child_style.width);
  
  // gap
  var gap = Number.isInteger(parseInt(getComputedStyle(sc_container).gap)) ? parseInt(getComputedStyle(sc_container).gap) : 0;


	// add navigation
	if(typeof settings.navigation !== 'undefined' && settings.navigation !== null){
		switch(settings.navigation){

			// prev / next navigation
			case 'prevnext':
				buildPrevNextNavigation();
				break;

			// prev / next navigation
			case 'paging':
				buildPagingNavigation();
				break;

			default:
				// no nothing
				break;

		}
	}

	// add autoplay
	const initiateAutoplay = () => {
		// only autoplay after video has loaded, as requires duration of video
		// queryselector will get the first video in the list only
		const video = sc_container.querySelector('video');
		if(video){
				hasVideoLoaded(video, autoplayCarousel);
		}else{
				autoplayCarousel();
		}

		// cancel autoplay on touch
		sc_container.addEventListener("touchstart", cancelAutoPlay);

	};

	if(settings.autoplay === true){
		initiateAutoplay();
	}


	// scroll listener
	sc_container.addEventListener('scroll', () => {
    updateCurrentPaging(); // call your function on scroll
	});





	// animation
	// =========================================================================================================================

	function slideCarousel(next_slide = false){
    
		// redefine width and gap in case of resize
		let first_child_style = getComputedStyle(sc_container.firstElementChild);
		item_width = first_child_style.minWidth === '100%' ? sc_container.firstElementChild.clientWidth : parseInt(first_child_style.width);
		var gap = Number.isInteger(parseInt(getComputedStyle(sc_container).gap)) ? parseInt(getComputedStyle(sc_container).gap) : 0;

		// find out the current slide in view
		var current_index = Math.floor(sc_container.scrollLeft / (item_width + gap));
    
    // adjust for items smaller than width of container
    var current_index_left = ((current_index * gap) + (current_index * item_width));

    if((sc_container.scrollLeft - 10) > current_index_left){ // use -10 to adjust for rounding
      current_index += 1;
    }

    // if sliding to specific number
		if(Number.isInteger(next_slide)){
			var next_index = next_slide;

    // if next
		}else if(next_slide === true){
			var next_index = current_index + 1;
      if(next_index >= sc_container.children.length){
          next_index = 0; // if no more items, go to first
      }

    // if previous
		}else{
      var next_index = current_index - 1;
      if(next_index < 0){
        next_index = sc_container.children.length - 1; // if no more items, go to last, adjusting for 0 index
      }
		}
    
    // calculate amount to scroll container to
    to_scroll_amount = (item_width * next_index);
    
    // need to get this programatically
    to_scroll_amount += gap * next_index; // add gap


    // if container at full scroll (adjusting for items smaller than container)
    if(next_slide === true){
      var width_of_all_items = (item_width * sc_container.children.length) + (gap * (sc_container.children.length - 1));
      // if scrolling again would match or exceed all items && item isn't 100% width
      //if((to_scroll_amount + item_width) >= width_of_all_items && item_width != sc_container.offsetWidth){
			if((sc_container.scrollLeft + sc_container.offsetWidth) >= width_of_all_items && item_width != sc_container.offsetWidth){
        to_scroll_amount = 0;
      }
    }

    // reduce by ten to avoid sub-pixels breaking the scroll
    to_scroll_amount -= 10;

		// update slider_container.scrollLeft
		sc_container.scrollLeft = to_scroll_amount;

		// update current
		updateCurrentPaging();

	}




	// autoplay
	// =========================================================================================================================

	// play
	function autoplayCarousel(){

		// find current slide (after scroll)
		const current_index = Math.floor(sc_container.scrollLeft / item_width);
    const current_slide = sc_container.children[current_index];
    const video = current_slide.querySelector('video');


		// get interval, minus scroll delay
		const calculateInterval = () => {
			return video ? getVideoLength(video) - scroll_interval : base_interval - scroll_interval;
		};


		const restartAutoplay = () => {
			// move to next slide
			slideCarousel(true);
			// delay restarting autoplay so current scroll has time to complete
			setTimeout(autoplayCarousel, scroll_interval);
		};

		// set autoplay
		autoplay_interval = setTimeout(restartAutoplay, calculateInterval());

	}

	// stop
	function cancelAutoPlay(){
		clearTimeout(autoplay_interval); 
	}




	// video
	// =========================================================================================================================

	// duration
	function getVideoLength(video){
		return video.duration * 1000; // convert to milliseconds
	}

	// has loaded
	function hasVideoLoaded(video, callback){

		// if video already loaded
		if(video.readyState == 4){
			if(typeof callback === 'function'){
				callback();
			}

		// else listen to onloadedmetadata event
		}else{
			video.onloadedmetadata = function(){
				if(typeof callback === 'function'){
					callback();
				}
			};
		}

	}




	// prev / next navigation
	// =========================================================================================================================

	// build
	function buildPrevNextNavigation(){

		const existing_nav = sc_container.querySelector('.scarousel__nav');

    if(!existing_nav){
        const nav_to_add = document.createElement("nav");
        nav_to_add.classList.add('scarousel__nav', 'scarousel__nav--prevnext');
        nav_to_add.innerHTML = '<a href="#"><span>Previous</span></a><a href="#"><span>Next</span></a>';
        sc_container.after(nav_to_add);

        nav = sc_container.nextElementSibling;

        bindPrevNextNavigation();
    }

	}


	// bind click
	function bindPrevNextNavigation(){

		// get nav links
		var nav_links = nav.querySelectorAll('a');

		// loop and attach click events
		[].forEach.call(nav_links, function(nl){
			nl.addEventListener('click', function(e){
				e.preventDefault();

				// prev
				if(!nl.previousElementSibling){
					slideCarousel();

				// next
				}else if(!nl.nextElementSibling){
					slideCarousel(true);
				}

				cancelAutoPlay();

			});
		});

	}




	// prev / next navigation
	// =========================================================================================================================

	// build
	function buildPagingNavigation(){

		const existing_nav = sc_container.querySelector('.scarousel__nav');

    if(!existing_nav){
        const nav_to_add = document.createElement("nav");
        nav_to_add.classList.add('scarousel__nav', 'scarousel__nav--paging');

				// works instead of for loop, creates array and implodes
        const navHtml = Array.from({ length: sc_container.children.length }, (_, i) => '<a href=\'#\'><span>' + (i + 1) + '</span></a>').join('');
        nav_to_add.innerHTML = navHtml;

        sc_container.after(nav_to_add);

        nav = sc_container.nextElementSibling;

        updateCurrentPaging();

        bindPagingNavigation();

    }

	}


	// bind click
	function bindPagingNavigation(){

		// get nav links
		var nav_links = nav.querySelectorAll('a');

		// loop and attach click events
		[].forEach.call(nav_links, function(nl){
			nl.addEventListener('click', function(e){
				e.preventDefault();

				// get index of current slide
				var next_slide = Array.prototype.indexOf.call(nl.parentElement.children, nl);

				slideCarousel(next_slide);

				updateCurrentPaging();
			
				cancelAutoPlay();

			});
		});

	}


	// update current pos
	function updateCurrentPaging(){

		// arrow function notation | name = [function/variables] [arrow] [contents]
		const clearPreviousCurrent = () => {
			const prevCurrent = nav.querySelector('[data-current]');
			if(prevCurrent){
				prevCurrent.removeAttribute('data-current');
			}
		};

		const setCurrentNavItem = () => {
				const current_index = Math.floor(sc_container.scrollLeft / item_width);
				const matching_nav_item = nav.children[current_index];
				if(matching_nav_item){
						matching_nav_item.setAttribute('data-current', true);
				}
		};

		// delay updating current until after scroll
		setTimeout(() => {
				clearPreviousCurrent();
				setCurrentNavItem();
		}, scroll_interval);

	}

}






// init all carousels
// =========================================================================================================================

window.addEventListener('load', function(){

	var all_scarousels = document.querySelectorAll('[data-scarousel]');
	all_scarousels.forEach(function(sc_container){

		// run only if carousel has more than 1 child
		var num_items = sc_container.children.length;
		if(num_items > 1){
			initScarousel(sc_container);
		}

	});

});